import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { AbandonedMine } from '@shared/models/records/abandoned-mine.model';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-abandoned-mine-record',
  templateUrl: './abandoned-mine-record.component.html',
  styleUrls: ['./abandoned-mine-record.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AbandonedMineRecordComponent extends BaseComponent implements OnInit, OnDestroy {

    record: AbandonedMine;
    searchTerms: string;

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.initRecord()
        this.loadOntarioExpandCollapse();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    private initRecord() {
        if(!history.state.data) {
            this.record = JSON.parse(this.searchResultsCache.getRecord());
        } else {
            this.record = history.state.data;
            this.searchTerms = history.state.searchTerms;
            this.searchResultsCache.setRecord(this.record);
        }

        const breadcrumb = {
            name: this.abandoned_mine_identifier,
            prefix: 'abandoned.mine.record',
            component: 'AbandonedMineRecordComponent',
        }      
        this.breadcrumbService.addBreadcrumb(breadcrumb);
    }

    get mdi_identifier_new() {
        return this.record.mdi_identifier_new;
    }

    get abandoned_mine_identifier() {
        return this.record.abandoned_mine_identifier;
    }

    get official_name() {
        return this.record.official_name;
    }

    get mine_site_class() {
        return this.record.mine_site_class;
    }

    get primary_commodity() {
        return this.record.primary_commodity;
    }

    get nts_number() {
        return this.record.nts_number;
    }

    get date_mineopened() {
        return this.record.date_mineopened;
    }

    get date_mineclosed() {
        return this.record.date_mineclosed;
    }

    get mine_site_status_code() {
        return this.record.mine_site_status_code;
    }

    get closure_plan() {
        return this.record.closure_plan;
    }

    get progressive_rehab_plan() {
        return this.record.progressive_rehab_plan;
    }

    get mine_plan_or_section() {
        return this.record.mine_plan_or_section;
    }

    get jurisdiction() {
        return this.record.jurisdiction;
    }

    get mndm_township_area_name() {
        return this.record.mndm_township_area_name;
    }

    get amis_district_description() {
        return this.record.amis_district_description;
    }

    get operational_access() {
        return this.record.operational_access;
    }

    get date_lastmodified() {
        return this.record.date_lastmodified;
    }
    get utm_zone() {
        return this.record.utm_zone;
    }

    get utm_northing() {
        return this.record.utm_northing;
    }

    get utm_easting() {
        return this.record.utm_easting;
    }

    get latitude_decimal_degrees() {
        return this.record.latitude_decimal_degrees;
    }

    get longitude_decimal_degrees() {
        return this.record.longitude_decimal_degrees;
    }

    get features() {
        if(this.record.features && this.record.features.length > 0) {
            return true;
        }
        return false;
    }

    get altNames() {
        if(this.record.alt_name && this.record.alt_name.length > 0) {
            return true;
        }
        return false;
    }

    get databaseIndex(): string {
        return DatabaseIndexNameType.abandonedMines;
    }

}